import PageHeader from '../../layout/page/PageHeader'
import ProfileForm from './ProfileForm'

const MyAccount = () => {
    return (
        <>
            <PageHeader
                icon="circle-user"
                subtitle="Manage your profile and account settings"
                gradient="linear-gradient(135deg, #6366f1, #4f46e5)"
                header="My Account"
            />
            <ProfileForm
                config={{
                    submitSuccessMsg: {
                        header: 'Updated',
                        message: 'Profile updated successfully',
                    },
                    submitFailedMsg: {
                        header: 'Failed',
                        message: 'Failed to update profile',
                    },
                    saveButton: {
                        label: 'Update',
                        savingLabel: 'Updating profile...',
                    },
                }}
            />
        </>
    )
}

export default MyAccount
